import React, {PropsWithChildren, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {
  SideBar,
  DashboardHeader,
} from '../layout';
import {FooterBottom} from './FooterBottom';
import { setDashboardSearchTerm } from '@/services/redux/slices';
import { useDispatch } from 'react-redux';

export const DashboardLayout: React.FC<PropsWithChildren> = props => {
  const {children} = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState(false);
  function handleSideBarClose() {
    setOpen(false);
  }

  function handleSideBarOpen() {
    setOpen(true);
  }

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    // reset the dashboard search term when the pathname changes
    dispatch(setDashboardSearchTerm(''));
  }, [location.pathname]);

  return (
    <div className="flex flex-col w-full h-screen overflow-y-auto scroll-hidden">
      <div className="flex min-h-screen flex-1 overflow-hidden">
        <div className="flex flex-col">
          <SideBar open={open} onClose={handleSideBarClose} />
        </div>
        <div ref={containerRef} className="flex-grow flex flex-col overflow-y-scroll">
          <DashboardHeader onSideBarOpen={handleSideBarOpen} />
          <div className="bg-[#F8FAFC] flex-grow flex flex-col">{children}</div>
        </div>
      </div>
      {/* Footer Bottom Section - spans full width */}
      <FooterBottom />
    </div>
  );
};
